import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./index.css";
import moment from "moment";
import "moment/locale/en-gb";
import ApolloConnection from "./ApolloConnection";

moment.locale("en-gb");

ReactDOM.render(
  <React.StrictMode>
    <ApolloConnection>
      <App />
    </ApolloConnection>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
